import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirditempotraveller() {



  const cardData = {
"keyword": "Pune to Shirdi Tempo Traveller",

"headingDescription":
  "Aaradhya Travels offers reliable Pune to Shirdi Tempo Traveller service for family pilgrimage tours, Sai Baba darshan trips, group travel, and outstation journeys. Our comfortable AC Tempo Travellers with experienced drivers ensure safe, spacious, and affordable travel from Pune to Shirdi with convenient pickup and smooth highway journeys.",

"topPlaces": [
  {
    "title": "Sai Baba Temple Shirdi",
    "description":
      "Sai Baba Temple is one of India’s most visited pilgrimage destinations attracting millions of devotees every year. Travelers from Pune frequently hire Tempo Travellers for comfortable family darshan tours, spiritual journeys, and group pilgrimage travel to seek blessings at the holy shrine."
  },
  {
    "title": "Dwarkamai",
    "description":
      "Dwarkamai is the sacred mosque where Sai Baba spent a significant part of his life. Devotees visit this spiritually important place to experience peace, devotion, and the divine atmosphere connected with Sai Baba’s teachings."
  },
  {
    "title": "Chavadi",
    "description":
      "Chavadi is an important religious site in Shirdi where Sai Baba used to rest on alternate nights. Pilgrims visiting Shirdi often include Chavadi in their darshan route for its spiritual and historical importance."
  },
  {
    "title": "Sai Heritage Village",
    "description":
      "Sai Heritage Village is a popular attraction near Shirdi showcasing Sai Baba’s life, rural village culture, spiritual exhibits, and family-friendly entertainment experiences."
  },
  {
    "title": "Shani Shingnapur",
    "description":
      "Shani Shingnapur is a famous pilgrimage destination near Shirdi dedicated to Lord Shani. Devotees often combine Shirdi and Shani Shingnapur travel in one spiritual road trip from Pune."
  },
  {
    "title": "Lendi Baug",
    "description":
      "Lendi Baug is a peaceful garden area where Sai Baba used to meditate daily. Visitors come here for spiritual calmness, prayer, and a peaceful atmosphere during their Shirdi pilgrimage."
  },
  {
    "title": "Khandoba Temple",
    "description":
      "Khandoba Temple is one of the first places where Sai Baba arrived in Shirdi. The temple holds great religious significance for devotees and is visited during temple tours."
  },
  {
    "title": "Sai Teerth Theme Park",
    "description":
      "Sai Teerth is India’s first devotional theme park offering spiritual entertainment, 5D shows, cultural exhibits, and interactive attractions based on Sai Baba’s life."
  },
  {
    "title": "Wet N Joy Water Park",
    "description":
      "Wet N Joy Water Park near Shirdi is a family entertainment destination featuring water slides, amusement rides, and recreational activities suitable for tourists and children."
  },
  {
    "title": "Gurusthan",
    "description":
      "Gurusthan is considered the place where Sai Baba was first seen meditating under a neem tree in Shirdi. Devotees visit this sacred place for spiritual blessings and peaceful prayer."
  },
  {
    "title": "Maruti Mandir",
    "description":
      "Maruti Mandir is a well-known Hanuman temple in Shirdi visited by devotees during temple darshan tours and spiritual travel experiences."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is a nearby pilgrimage and tourist destination famous for Trimbakeshwar Temple, vineyards, river ghats, and spiritual tourism. Many travelers combine Nashik with Shirdi group tours."
  },
  {
    "title": "Trimbakeshwar Temple",
    "description":
      "Trimbakeshwar Temple is one of the twelve Jyotirlinga temples dedicated to Lord Shiva located near Nashik. Pilgrims often include this sacred temple in their Shirdi Tempo Traveller journey."
  },
  {
    "title": "Saptashrungi Temple",
    "description":
      "Saptashrungi Temple is a famous hill temple dedicated to Goddess Saptashrungi Devi attracting devotees from across Maharashtra for religious visits."
  },
  {
    "title": "Pandavleni Caves",
    "description":
      "Pandavleni Caves near Nashik are ancient Buddhist rock-cut caves known for historical carvings, architecture, and hilltop views attracting tourists and history lovers."
  },
  {
    "title": "Anjaneri Hills",
    "description":
      "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is popular for trekking, spiritual tourism, and scenic landscapes near Nashik."
  },
  {
    "title": "Godavari Ghat Nashik",
    "description":
      "Godavari Ghat is a sacred riverbank area in Nashik visited by pilgrims for religious rituals, holy baths, and spiritual tourism experiences."
  },
  {
    "title": "Coin Museum Nashik",
    "description":
      "Coin Museum in Nashik displays rare Indian coins and historical collections attracting tourists interested in history and heritage tourism."
  },
  {
    "title": "Muktidham Temple",
    "description":
      "Muktidham Temple is a famous marble temple in Nashik known for replicas of sacred Hindu temples and peaceful spiritual surroundings."
  },
  {
    "title": "Vani Temple",
    "description":
      "Vani Temple near Nashik is a popular religious destination visited by pilgrims traveling through Maharashtra temple circuits and spiritual tours."
  }
],



services: [
  {
    name: "Pune to Shirdi Tempo Traveller on Rent",
    description: "Pune to Shirdi Tempo Traveller on rent service provides comfortable transportation for Sai Baba darshan tours, family pilgrimages, group travel, and spiritual journeys from Pune. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller on Rent",
    description: "Pune Airport to Shirdi Tempo Traveller on rent service offers direct airport pickup transportation for devotees, tourists, and family groups traveling to Shirdi from Pune Airport. Spacious vehicles ensure comfortable luggage handling and smooth long-distance journeys suitable for temple travel. Professional chauffeurs ensure timely airport pickup and dependable transportation services throughout the route. Pickup services are available directly from Pune Airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport traveller reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller AC 13 & 17 Seater",
    description: "Pune to Shirdi Tempo Traveller AC 13 & 17 seater service provides premium air-conditioned transportation for pilgrimage tours, family travel, and group darshan trips from Pune. Comfortable pushback seating and spacious interiors ensure smooth highway journeys suitable for long-distance spiritual travel. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller on Rent",
    description: "Pune to Shirdi Tempo Traveller on rent service offers dependable transportation for temple visits, family darshan tours, spiritual tourism, and pilgrimage journeys. Spacious vehicles ensure comfortable seating and luggage capacity suitable for devotees and tourist groups. Professional chauffeurs ensure safe highway driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Pune to Shirdi Mini Bus Rent",
    description: "Pune to Shirdi mini bus rent service provides spacious transportation for large family groups, pilgrimage tours, educational trips, and spiritual journeys from Pune. Comfortable seating and smooth highway travel ensure pleasant experiences suitable for devotees and senior citizens. Professional drivers ensure safe transportation and punctual pickup services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Bus Hire for Pune to Shirdi",
    description: "Bus hire for Pune to Shirdi service offers reliable transportation for Sai Baba temple visits, family tours, spiritual journeys, and group darshan trips from Pune. Spacious buses ensure smooth highway travel suitable for pilgrims, tourist groups, and educational travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller",
    description: "Pune Airport to Shirdi Tempo Traveller service provides direct airport transportation for devotees and travelers arriving in Pune for Shirdi temple visits. Spacious vehicles ensure comfortable luggage handling and smooth long-distance travel suitable for family and group journeys. Professional chauffeurs ensure timely airport pickup and reliable transportation services throughout the route. Pickup services are available directly from airport terminals with flexible timing options. Convenient booking options allow easy airport traveller reservations."
  },
  {
    name: "Pune to Shani Shingnapur Tempo Traveller",
    description: "Pune to Shani Shingnapur Tempo Traveller service offers comfortable transportation for spiritual journeys, temple darshan tours, and family pilgrimage travel from Pune. Spacious vehicles ensure smooth highway travel suitable for devotees, senior citizens, and tourist groups. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shani Shingnapur traveller reservations."
  },
  {
    name: "Pune to Shani Shingnapur Bus on Rent",
    description: "Pune to Shani Shingnapur bus on rent service provides reliable group transportation for temple visits, spiritual tourism, pilgrimage tours, and family darshan journeys. Comfortable buses ensure smooth long-distance travel suitable for all passenger groups and devotees. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shani Shingnapur bus reservations."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller",
    description: "Pune Airport to Shirdi Tempo Traveller service offers premium airport pickup transportation for tourists, families, and pilgrimage groups heading to Shirdi Sai Baba temple from Pune Airport. Spacious seating and luggage space ensure comfortable travel experiences suitable for long-distance journeys. Professional drivers ensure safe driving and timely pickup services throughout the route. Pickup services are available directly from airport terminals with flexible scheduling options. Convenient booking options allow hassle-free airport traveller reservations."
  },
  {
    name: "Pune to Shirdi 14 Seater Bus on Rent",
    description: "Pune to Shirdi 14 seater bus on rent service provides comfortable transportation for medium-sized family groups, pilgrimage tours, and spiritual travel from Pune. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 14 seater bus reservations."
  },
  {
    name: "Pune to Shirdi 17 Seater on Rent",
    description: "Pune to Shirdi 17 seater on rent service offers spacious transportation for large family groups, temple tours, educational travel, and pilgrimage journeys from Pune. Comfortable seating and luggage capacity ensure smooth highway travel suitable for group darshan trips. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "Pune to Ahmednagar Tempo Traveller on Rent",
    description: "Pune to Ahmednagar Tempo Traveller on rent service provides dependable transportation for business travel, family tours, pilgrimage visits, and tourist journeys from Pune. Spacious vehicles ensure comfortable highway travel suitable for long-distance and local travel requirements. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Ahmednagar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ahmednagar traveller reservations."
  },
  {
    name: "Pune to Ajanta Ellora Tempo Traveller on Rent",
    description: "Pune to Ajanta Ellora Tempo Traveller on rent service offers premium transportation for heritage tourism, family vacations, educational tours, and sightseeing journeys from Pune. Comfortable seating and spacious interiors ensure pleasant long-distance travel experiences for tourists and groups. Professional drivers ensure safe highway driving and dependable transportation services throughout the Ajanta Ellora route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pune",
    description: "17 seater Tempo Traveller on rent in Pune service provides spacious and comfortable transportation for family vacations, airport transfers, corporate outings, wedding travel, and outstation journeys. Comfortable pushback seating and luggage capacity ensure smooth highway travel suitable for group passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller Package",
    description: "Pune to Shirdi Tempo Traveller package service provides complete transportation solutions for Sai Baba darshan tours, pilgrimage travel, family journeys, and spiritual group trips from Pune. Spacious vehicles ensure comfortable seating and smooth highway travel suitable for devotees and senior citizens. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi package traveller reservations."
  }
],

tableData: [
  ["Pune to Shirdi Tempo Traveller on Rent", "Pune Airport to Shirdi Tempo Traveller on Rent"],
  ["Pune to Shirdi Tempo Traveller AC 13 & 17 Seater", "Pune to Shirdi Tempo Traveller on Rent"],
  ["Pune to Shirdi Mini Bus Rent", "Bus Hire for Pune to Shirdi"],
  ["Pune Airport to Shirdi Tempo Traveller", "Pune to Shani Shingnapur Tempo Traveller"],
  ["Pune to Shani Shingnapur Bus on Rent", "Pune Airport to Shirdi Tempo Traveller"],
  ["Pune to Shirdi 14 Seater Bus on Rent", "Pune to Shirdi 17 Seater on Rent"],
  ["Pune to Ahmednagar Tempo Traveller on Rent", "Pune to Ajanta Ellora Tempo Traveller on Rent"],
  ["17 Seater Tempo Traveller on Rent in Pune", "Pune to Shirdi Tempo Traveller Package"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Shirdi Tempo Traveller Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Shirdi Tempo Traveller service with comfortable vehicles, professional drivers, and smooth travel arrangements for Sai Baba darshan and group pilgrimage tours."
      },
      {
        WhyChooseheading: "Affordable Shirdi Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Shirdi Tempo Traveller rental packages with transparent pricing, flexible travel plans, and complete booking support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking from Pune",
        WhyChoosedescription: "Our Pune to Shirdi Tempo Traveller booking service is available 24 hours for family pilgrimage tours, Sai Baba darshan trips, weekend travel, and customized temple journeys."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for comfortable long-distance pilgrimage travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Shirdi Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers one-day Shirdi darshan tours, weekend pilgrimage trips, and customized multi-day temple travel packages from Pune."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for families, Sai devotees, tourist groups, and corporate travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Shirdi highway and temple routes, ensuring safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Shirdi Tempo Traveller service?", answer: "Pune to Shirdi Tempo Traveller service provides comfortable group transportation for Sai Baba darshan, pilgrimage tours, and family travel." },
    { question: "Is Pune to Shirdi Tempo Traveller service available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller booking service from Pune to Shirdi." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book a one-day Shirdi trip from Pune?", answer: "Yes, customers can book one-day as well as multi-day Shirdi Tempo Traveller tour packages." },
    { question: "Do you provide customized Shirdi travel packages?", answer: "Yes, Aaradhya Travels provides customized Shirdi tour packages according to customer travel requirements." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable pilgrimage travel." },
    { question: "Can I book Pune to Shirdi Tempo Traveller online?", answer: "Yes, customers can easily book Tempo Traveller service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for family and group tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for families, Sai devotees, and group travel." },
    { question: "Are Pune to Shirdi Tempo Traveller charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Shirdi Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Jadhav",
    feedback:
      "The Pune to Shirdi journey with Aaradhya Travels in a Tempo Traveller was very smooth and peaceful. The vehicle was comfortable for a long pilgrimage, and the entire trip felt well organized.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Varsha Kulkarni",
    feedback:
      "Aaradhya Travels provided a Tempo Traveller for our Pune to Shirdi trip, and the experience was excellent. The ride was steady, the seating was comfortable, and everyone enjoyed a stress-free journey.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Tempo Traveller",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-shirdi-tempo-traveller.jpg",
  "description": "Book Pune to Shirdi Tempo Traveller with Aaradhya Travels for pilgrimage trips, family tours, airport transfers, and group travel. Affordable AC 13 and 17 seater tempo traveller available for Shirdi, Shani Shingnapur, Ahmednagar, and Ajanta Ellora tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4021"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-shirdi-tempo-traveller"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Shirdi Tempo Traveller | AC 13 & 17 Seater Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune to Shirdi Tempo Traveller with Aaradhya Travels. Affordable AC 13 and 17 seater tempo traveller available for Shirdi Sai Baba temple trips, Shani Shingnapur, Ahmednagar, Ajanta Ellora tours, airport transfers, and pilgrimage travel."
  />

  <meta
    name="keywords"
    content="Pune to Shirdi Tempo Traveller on Rent, Pune Airport to Shirdi Tempo Traveller on Rent, Pune to Shirdi Tempo Traveller AC 13 & 17 Seater, Pune to Shirdi Mini Bus Rent, Bus Hire for Pune to Shirdi, Pune airport to shirdi tempo traveller, pune to shani shingnapur tempo traveller, pune to shani shingnapur bus on rent, Pune Airport to Shirdi Tempo Traveller, pune to shirdi 14 seater bus on rent, Pune to shirdi 17 seater on rent, Pune to ahmednagar tempo traveller on rent, Pune to Ajanta Ellora"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirditempotraveller;